var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('router-view'),_c('div',{staticClass:"footer"},[_c('button',{on:{"click":function($event){return _vm.$router.push({name:'category'})}}},[_vm._v("シミュレータ画面にもどる")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }